import { OnInit } from '@angular/core';
var PageNotFoundComponent = /** @class */ (function () {
    function PageNotFoundComponent() {
    }
    PageNotFoundComponent.prototype.ngOnInit = function () { };
    return PageNotFoundComponent;
}());
export { PageNotFoundComponent };
